import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

const ClassList = (props) => {
  const navigate = useNavigate();

  const handleClassClick = (classId, className) => {
    // navigate to the ClassDetails page with the classId prop
    navigate('/class',{ state: { classId, className } });


  };

  const ClassListItem = ({ title, subTitle, classId }) => {
    return (
      <div
        onClick={()=>{handleClassClick(classId, title)}}
        style={{
          width: '500px',
          background: ' #4F7781',
          borderRadius: '8px',
        color: 'white',
          padding: '20px 20px',
          textAlign: 'center',
          marginRight: 30,
          marginBottom: 30,
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        <h1>{title}</h1>
        <p>{subTitle}</p>
      </div>
    );
  };

  return (
    <div
      style={{
        width: '75%',
        margin: 'auto',
      }}
    >
      <h1
        style={{
          color: '#453654',
          fontSize: 45,
        }}
      >
        All Classes
      </h1>
      <hr />
      <h3
        style={{
          marginVertical: 10,
          textAlign: 'center',
        }}
      >
        List of all classes
      </h3>
      <Grid
        style={{ paddingTop: '80px' }}
        container
        rowSpacing={3}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <ClassListItem classId={1} title='Class I' subTitle='8 teachers, 49 students'  />
        <ClassListItem classId={2} title='Class II' subTitle='7 teachers, 53 students' />
        <ClassListItem classId={3} title='Class III' subTitle='9 teachers, 45 students' />
      </Grid>
    </div>
  );
};

export default ClassList;
